import { Shell } from './components/Shell';
import { useRoute } from './lib/router';
import { ChallengePlayScreen } from './screens/ChallengePlayScreen';
import { DailyScreen } from './screens/DailyScreen';
import { JourneyScreen } from './screens/JourneyScreen';
import { MyChallengesScreen } from './screens/MyChallengesScreen';
import { NewChallengeScreen } from './screens/NewChallengeScreen';
import { NotFoundScreen } from './screens/NotFoundScreen';

export function App() {
  const route = useRoute();
  return (
    // I5: the sm:h-auto/min-h-[100dvh] opt-out let desktop windows grow the
    // document taller than the viewport (keyboard/footer pushed
    // below-the-fold). Keeping h-[100dvh] at every breakpoint, with the
    // flexible board mechanism (index.css) active everywhere too, caps the
    // whole column to the viewport the same way mobile always has —
    // the board just shrinks (down to its 68px-tile cap) to make room.
    <div className="mx-auto flex h-[100dvh] w-full max-w-app flex-col gap-1 px-3 pt-safe pb-safe sm:gap-4 sm:px-4 sm:py-6">
      <Shell>
        {route.name === 'daily' ? <DailyScreen />
          : route.name === 'journey' ? <JourneyScreen />
          : route.name === 'new-challenge' ? <NewChallengeScreen />
          : route.name === 'my-challenges' ? <MyChallengesScreen />
          : route.name === 'challenge' ? <ChallengePlayScreen code={route.code} hash={route.hash} />
          : <NotFoundScreen />}
      </Shell>
    </div>
  );
}
